import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const Wrapper = styled('div')(
  {
    alignItems: 'center',
    borderRadius: 6,
    borderStyle: 'solid',
    borderWidth: 1,
    display: 'flex',
    gap: 10,
    height: 94,
    paddingLeft: 17,
    paddingRight: 34,
    position: 'relative',
    [media('xs')]: {
      width: '100%'
    },
    [media('lg')]: {
      width: 'auto'
    }
  },
  ({ theme }) => ({
    borderColor: theme.palette.colors.columbiaBlue
  })
);

export default Wrapper;
